import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hdd': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M567.4 235.6c5.6 8 8.6 17.6 8.6 27.4v136.9c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-136.9c0-8.3 3.9-20.6 8.6-27.4l105.1-151.1c7.9-11.4 25.6-20.6 39.4-20.6h0 269.8 0c13.8 0 31.5 9.2 39.4 20.6zM153.1 112l-77.9 112h425.7l-77.9-112h-269.8zM528 400v-128h-480v128h480zM496 336c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM400 336c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z'
      }
    ]
  }
})
